<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        style="transform: scaleX(-1)"
    >
        <path
            d="M5.24445 15.1921C5.15654 15.1921 5.0706 15.166 4.9975 15.1172C4.92441 15.0684 4.86744 14.9989 4.83381 14.9177C4.80017 14.8365 4.79138 14.7471 4.80854 14.6609C4.8257 14.5747 4.86805 14.4955 4.93023 14.4333L11.128 8.23555L4.95867 2.06655C4.87685 1.98289 4.83133 1.87035 4.83197 1.75334C4.83262 1.63633 4.87938 1.52429 4.96211 1.44154C5.04485 1.3588 5.15687 1.31201 5.27388 1.31135C5.39089 1.31068 5.50345 1.35619 5.58712 1.43799L12.0703 7.92121C12.1116 7.96248 12.1443 8.01148 12.1667 8.0654C12.189 8.11933 12.2005 8.17712 12.2005 8.23549C12.2005 8.29386 12.189 8.35165 12.1667 8.40558C12.1443 8.4595 12.1116 8.5085 12.0703 8.54977L5.55812 15.0619C5.51697 15.1032 5.46809 15.1359 5.41426 15.1583C5.36044 15.1806 5.30273 15.1921 5.24445 15.1921Z"
            fill="#575757"
        />
    </svg>
</template>
